import { FunctionComponent } from 'react';
import { useFragment, graphql } from 'react-relay';

import { CheckoutAddressReview_address$key } from './__generated__/CheckoutAddressReview_address.graphql';

type CheckoutAddressReviewProps = {
    address: CheckoutAddressReview_address$key | null;
};

export const CheckoutAddressReview: FunctionComponent<CheckoutAddressReviewProps> = props => {
    const address = useFragment(
        graphql`
            fragment CheckoutAddressReview_address on Address {
                company
                formattedAddress
                displayCountry
            }
        `,
        props.address
    );

    const { company, formattedAddress, displayCountry } = address || {};

    return (
        <>
            {company && <div>{company}</div>}
            <div>{formattedAddress?.map(line => line).join(', ')}</div>
            <div>{displayCountry}</div>
        </>
    );
};
